import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from 'Components/CustomButton/CustomButton'
import ComboBox from 'Components/ComboBox'
import FileUploadIcon from '@mui/icons-material/FileUpload'

import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'

import { styled } from '@mui/material/styles'
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const Input = styled('input')({
  display: 'none',
})

export default function UploadOperations({ update = null, openFromWizard = false, onCloseImport = null }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(openFromWizard)
  const [accounts, setAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState([])
  const [numeroCompte, setNumeroCompte] = useState(null)
  const [file, setFile] = useState(null)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    if (openFromWizard) {
      setOpen(true)
    }
  }, [openFromWizard])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    if (onCloseImport) {
      onCloseImport()
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (numeroCompte === null || numeroCompte === '' || file === '' || file === null) {
      alert('Please Select Nom Compte')
    } else {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('NumeroCompte', numeroCompte)
      const response = await makePostRequest(
        urls.addBulkOperations,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
        true,
      )
      if (response.status === 201 || response.status === 200) {
        handleClose()
        if (update) {
          update()
        }
      }
    }
  }

  return (
    <>
      {/* LAP-733 (GE022) */}
      {isMobile ? (
        <Box onClick={handleClickOpen}>{t('contacts.btnImport')}</Box>
      ) : (
        <CustomButton onClick={handleClickOpen}>{t('contacts.btnImport')}</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Import Contacts</DialogTitle>
        <form onSubmit={onSubmit}>
          <DialogContent>
            <label htmlFor="contact_csv">
              <Input
                accept=".csv"
                id="contact_csv"
                onChange={(e) => setFile(e.target.files[0])}
                type="file"
              />
              <Stack mt={2} justifyContent="center" width={'100%'}>
                <Button variant="outlined" component="span" startIcon={<FileUploadIcon />}>
                  Upload contact CSV
                </Button>
              </Stack>
            </label>
            <br />
            <a href="/contact_template.csv">Template contact CSV</a>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
